<template>
<div>
  <b-card class="mt-3" header="Codles em falta">
    <grid-local :name="'missingCodleGrid'" v-bind:url="url" v-bind:columns="columns" v-bind:schemaModelFields="schemaModelFields"></grid-local>
  </b-card>
</div>
</template>

<script>
import GridLocal from '@/components/GridLocal.vue'
export default {
  name: 'mpg',
  components: {
    GridLocal
  },
  data() {
    return {
      url: 'missing/codles',
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      columns: [{
        field: 'codle',
        title: 'Codle'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// missingcodles.vue?ebd66018